import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const LoveSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M20.0032 7.7508C19.7488 7.17332 19.3819 6.65002 18.923 6.21019C18.4639 5.76904 17.9225 5.41846 17.3284 5.17753C16.7124 4.9267 16.0516 4.79831 15.3845 4.79982C14.4486 4.79982 13.5355 5.051 12.742 5.52547C12.5521 5.63897 12.3718 5.76363 12.2009 5.89946C12.0301 5.76363 11.8497 5.63897 11.6599 5.52547C10.8664 5.051 9.95327 4.79982 9.01738 4.79982C8.34346 4.79982 7.69042 4.92634 7.07345 5.17753C6.47737 5.41941 5.94013 5.76735 5.47883 6.21019C5.01942 6.64952 4.65243 7.17295 4.39866 7.7508C4.13478 8.35179 4 8.98999 4 9.64679C4 10.2664 4.12909 10.912 4.38537 11.5688C4.59988 12.1177 4.90742 12.6871 5.30038 13.262C5.92304 14.1719 6.77921 15.1208 7.84229 16.0828C9.60397 17.6773 11.3486 18.7788 11.4226 18.8235L11.8725 19.1063C12.0718 19.231 12.3281 19.231 12.5275 19.1063L12.9774 18.8235C13.0514 18.777 14.7941 17.6773 16.5577 16.0828C17.6208 15.1208 18.4769 14.1719 19.0996 13.262C19.4926 12.6871 19.802 12.1177 20.0146 11.5688C20.2709 10.912 20.4 10.2664 20.4 9.64679C20.4019 8.98999 20.2671 8.35179 20.0032 7.7508Z"
				fill="#4A4A4A"
			/>
			<path
				d="M18.9233 6.21019C19.3821 6.65002 19.749 7.17332 20.0035 7.7508C20.2673 8.35179 20.4021 8.98999 20.4002 9.64679C20.4002 10.2664 20.2711 10.912 20.0148 11.5688C19.8022 12.1177 19.4928 12.6871 19.0998 13.262C18.4772 14.1719 17.621 15.1208 16.5579 16.0828C14.7943 17.6773 13.0516 18.777 12.9776 18.8235C12.9776 18.8235 12.4661 19.1998 12.4004 19.1998H12.2012V5.89946C12.372 5.76363 12.5524 5.63897 12.7422 5.52547C13.5357 5.051 14.4488 4.79982 15.3847 4.79982C16.0518 4.79831 16.7126 4.9267 17.3287 5.17753C17.9228 5.41846 18.4641 5.76904 18.9233 6.21019Z"
				fill="url(#paint0_linear_22046_20235)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_22046_20235"
					x1="9.00039"
					y1="16.5998"
					x2="20.4004"
					y2="8.1998"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5C90FC" />
					<stop offset="1" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</IPortIconTemplate>
	)
})
